import { FieldErrorMap } from "hooks/useFieldErrors";
import i18n from "locales/i18n";
import { validateEmail, validatePassword } from "pages/formTools";

// Resolves the language per call, so messages follow the switcher.
const ta = i18n.getFixedT(null, "auth");

export interface EmailFormValues {
  email: string;
  password: string;
  confirmPassword: string;
}

export const validateEmailForm = (data: EmailFormValues): FieldErrorMap => ({
  email: validateEmail({
    name: ta("fields.email"),
    value: data.email,
    required: true,
  }),

  password: validatePassword({
    name: ta("fields.password"),
    value: data.password,
    required: true,
  }),

  confirmPassword:
    data.confirmPassword === data.password
      ? null
      : ta("common.password_mismatch"),
});
